import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { errorPageMiddleware } from '@saucelabs/sl-container-error-pages';
import { createBrowserHistory } from 'history';
import { ravenCrashReporter, historyRedirectMiddleware } from '@saucelabs/sl-util-redux';
import thunk from 'redux-thunk';

import createRootReducer from './reducers';

export const browserHistory = createBrowserHistory({ basename: '' });

const middlewares = [
  applyMiddleware(
    ravenCrashReporter,
    thunk,
    historyRedirectMiddleware,
    errorPageMiddleware(),
  ),
  applyMiddleware(routerMiddleware(browserHistory)),
];


if (window.__REDUX_DEVTOOLS_EXTENSION__) { // eslint-disable-line
  middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__()); // eslint-disable-line
}

const store = createStore(
  createRootReducer(browserHistory),
  {},
  compose(...middlewares),
);

if (module.hot) {
  module.hot.accept('./reducers', () => {
    // eslint-disable-next-line global-require
    const nextRootReducer = require('./reducers');

    store.replaceReducer(nextRootReducer);
  });
}

export default store;
